import { Action_StorePreRegistrationDetails,
    Action_StorePreRegistrationValidationResult,
    Action_ClearPreRegistrationInfo,
    Action_SetGDPRCOMPLIANCE,
    Action_SetCurrentUser,
    Action_ClearCurrentUser,
    Action_StoreForgotPasswordDetails,
    Action_ClearForgotPasswordDetails,
    Action_SetAgentUserObjectToCompleteRegistration,
    Action_Set_CurrentUserType} from './actions';

export function SharedReducer(state, action) {
    switch (action.type) {
        case 'SET_PRE_REGISTER_INFO':
        //console.log(`preRegisterInfo: ${action.payload}`);
        return {
            ...state,
            preRegisterInfo: action.payload
        };
        case Action_StorePreRegistrationDetails:
            return {
                ...state,
                preRegistrationDetails: action.payload
            };
        case Action_StorePreRegistrationValidationResult:
            return {
                ...state,
                preRegistrationValidationResult: action.payload
            };
        case Action_ClearPreRegistrationInfo:
            return {
                ...state,
                preRegistrationDetails: null,
                preRegistrationValidationResult: null
            };
        case Action_SetGDPRCOMPLIANCE:
            return {
                ...state,
                preRegistrationDetails: {
                                            ...state.preRegistrationDetails,
                                            IsGdprCompliant: action.payload,
                                        }
            };
        case Action_SetCurrentUser:
            return {
                ...state,
                currentUser: action.payload
            };
        case Action_ClearCurrentUser:
            return {
                ...state,
                currentUser: null
            };
        case Action_StoreForgotPasswordDetails:
            return {
                ...state,
                forgotPasswordDetails: action.payload
            };
        case Action_ClearForgotPasswordDetails:
            return {
                ...state,
                forgotPasswordDetails: null
            };
        case Action_SetAgentUserObjectToCompleteRegistration:
            return {
                ...state,
                agentUserObject: action.payload
            };
        case Action_Set_CurrentUserType:
        //console.log(`shared reducer: action.payload: ${action.payload}`);
            return {
                ...state,
                userType: action.payload
            };
    default:
        return state;
    }
}


